/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} App_Subscription_View_StatusInputs */

const nl_app_subscription_view_status = /** @type {(inputs: App_Subscription_View_StatusInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bekijk status`)
};

/**

* @param {App_Subscription_View_StatusInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const app_subscription_view_status = /** @type {((inputs?: App_Subscription_View_StatusInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<App_Subscription_View_StatusInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_app_subscription_view_status(inputs)
});
export { app_subscription_view_status as "app.subscription.view_status" }